import sellyApi from "./sellyApi"


export const getPqrsCategories = async (locale) => {
    try {
        const { data } = await sellyApi.get(`/pqrs/types`, {params: {locale}});
        return data;
    } catch (error) {
        console.error('Error obteniendo categorias de pqrs', error);
    }
}

export const getPqrsServicios = async (locale) => {
    try {
        const { data } = await sellyApi.get(`/pqrs/servicios`, {params: {locale}});
        return data;
    } catch (error) {
        console.error('Error obteniendo servicios de pqrs', error);
    }
}

export const getPqrsNovedades = async (locale) => {
    try {
        const { data } = await sellyApi.get(`/pqrs/novedades`, {params: {locale}});
        return data;
    } catch (error) {
        console.error('Error obteniendo novedades de pqrs', error);
    }
}


export const getPqrsCausas = async (locale) => {
    try {
        const { data } = await sellyApi.get(`/pqrs/causas`, {params: {locale}});
        return data;
    } catch (error) {
        console.error('Error obteniendo causas de pqrs', error);
    }
}

export const sendPqrs = async (formItems) => {
    const formData = new FormData();
    for(const formItem in formItems) {
        formData.append(formItem, formItems[formItem]);
    }
    try {
        const { data } = await sellyApi.postForm(`/pqrs/`, formData, {'Content-Type': 'multipart/form-data'});
        return data;
    } catch (error) {
        console.error('Error mandando pqrs', error);
        throw error;
    }
}